/**
 * Biker BFF API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CustomersSubscriptionsPendingGet200Response model module.
 * @module model/CustomersSubscriptionsPendingGet200Response
 * @version 1.0.0
 */
class CustomersSubscriptionsPendingGet200Response {
    /**
     * Constructs a new <code>CustomersSubscriptionsPendingGet200Response</code>.
     * @alias module:model/CustomersSubscriptionsPendingGet200Response
     */
    constructor() { 
        
        CustomersSubscriptionsPendingGet200Response.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CustomersSubscriptionsPendingGet200Response</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CustomersSubscriptionsPendingGet200Response} obj Optional instance to populate.
     * @return {module:model/CustomersSubscriptionsPendingGet200Response} The populated <code>CustomersSubscriptionsPendingGet200Response</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CustomersSubscriptionsPendingGet200Response();

            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('productId')) {
                obj['productId'] = ApiClient.convertToType(data['productId'], 'Number');
            }
            if (data.hasOwnProperty('pSim')) {
                obj['pSim'] = ApiClient.convertToType(data['pSim'], 'Number');
            }
            if (data.hasOwnProperty('gatewayCustomerId')) {
                obj['gatewayCustomerId'] = ApiClient.convertToType(data['gatewayCustomerId'], 'String');
            }
            if (data.hasOwnProperty('gatewayPriceId')) {
                obj['gatewayPriceId'] = ApiClient.convertToType(data['gatewayPriceId'], 'String');
            }
            if (data.hasOwnProperty('activated')) {
                obj['activated'] = ApiClient.convertToType(data['activated'], 'Boolean');
            }
            if (data.hasOwnProperty('registered')) {
                obj['registered'] = ApiClient.convertToType(data['registered'], 'Boolean');
            }
            if (data.hasOwnProperty('orderCompleted')) {
                obj['orderCompleted'] = ApiClient.convertToType(data['orderCompleted'], 'Boolean');
            }
            if (data.hasOwnProperty('iccid')) {
                obj['iccid'] = ApiClient.convertToType(data['iccid'], 'String');
            }
            if (data.hasOwnProperty('promoCode')) {
                obj['promoCode'] = ApiClient.convertToType(data['promoCode'], 'String');
            }
            if (data.hasOwnProperty('orderDate')) {
                obj['orderDate'] = ApiClient.convertToType(data['orderDate'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CustomersSubscriptionsPendingGet200Response</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CustomersSubscriptionsPendingGet200Response</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }
        // ensure the json data is a string
        if (data['gatewayCustomerId'] && !(typeof data['gatewayCustomerId'] === 'string' || data['gatewayCustomerId'] instanceof String)) {
            throw new Error("Expected the field `gatewayCustomerId` to be a primitive type in the JSON string but got " + data['gatewayCustomerId']);
        }
        // ensure the json data is a string
        if (data['gatewayPriceId'] && !(typeof data['gatewayPriceId'] === 'string' || data['gatewayPriceId'] instanceof String)) {
            throw new Error("Expected the field `gatewayPriceId` to be a primitive type in the JSON string but got " + data['gatewayPriceId']);
        }
        // ensure the json data is a string
        if (data['iccid'] && !(typeof data['iccid'] === 'string' || data['iccid'] instanceof String)) {
            throw new Error("Expected the field `iccid` to be a primitive type in the JSON string but got " + data['iccid']);
        }
        // ensure the json data is a string
        if (data['promoCode'] && !(typeof data['promoCode'] === 'string' || data['promoCode'] instanceof String)) {
            throw new Error("Expected the field `promoCode` to be a primitive type in the JSON string but got " + data['promoCode']);
        }
        // ensure the json data is a string
        if (data['orderDate'] && !(typeof data['orderDate'] === 'string' || data['orderDate'] instanceof String)) {
            throw new Error("Expected the field `orderDate` to be a primitive type in the JSON string but got " + data['orderDate']);
        }

        return true;
    }


}



/**
 * @member {String} email
 */
CustomersSubscriptionsPendingGet200Response.prototype['email'] = undefined;

/**
 * @member {Number} productId
 */
CustomersSubscriptionsPendingGet200Response.prototype['productId'] = undefined;

/**
 * @member {Number} pSim
 */
CustomersSubscriptionsPendingGet200Response.prototype['pSim'] = undefined;

/**
 * @member {String} gatewayCustomerId
 */
CustomersSubscriptionsPendingGet200Response.prototype['gatewayCustomerId'] = undefined;

/**
 * @member {String} gatewayPriceId
 */
CustomersSubscriptionsPendingGet200Response.prototype['gatewayPriceId'] = undefined;

/**
 * @member {Boolean} activated
 */
CustomersSubscriptionsPendingGet200Response.prototype['activated'] = undefined;

/**
 * @member {Boolean} registered
 */
CustomersSubscriptionsPendingGet200Response.prototype['registered'] = undefined;

/**
 * @member {Boolean} orderCompleted
 */
CustomersSubscriptionsPendingGet200Response.prototype['orderCompleted'] = undefined;

/**
 * @member {String} iccid
 */
CustomersSubscriptionsPendingGet200Response.prototype['iccid'] = undefined;

/**
 * Promotional code if provided
 * @member {String} promoCode
 */
CustomersSubscriptionsPendingGet200Response.prototype['promoCode'] = undefined;

/**
 * @member {String} orderDate
 */
CustomersSubscriptionsPendingGet200Response.prototype['orderDate'] = undefined;






export default CustomersSubscriptionsPendingGet200Response;

